import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/form.css'; // por si tenés estilos personalizados

const AuthHome = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column justify-content-center align-items-center bg-light text-center px-3">
      <img
        src="/logo-mesapp.png"
        alt="Logo de MesaApp"
        className="mb-4"
        style={{ maxWidth: '180px' }}
      />
      <h2 className="mb-3">¡Bienvenido a MesaApp!</h2>
      <p className="mb-4">Elegí una opción para continuar:</p>
      <div className="d-flex flex-column gap-3" style={{ width: '100%', maxWidth: '300px' }}>
        <button className="btn btn-primary" onClick={() => navigate('/login')}>
          Iniciar sesión
        </button>
        <button className="btn btn-outline-primary" onClick={() => navigate('/register')}>
          Registrarme
        </button>
      </div>
      <small className="text-muted mt-4">
  Simplificá la toma de pedidos y la gestión del salón en un solo lugar.
</small>
    </div>
  );
};

export default AuthHome;
